import { render } from "./MugenScroll.vue?vue&type=template&id=57c39222&scoped=true"
import script from "./MugenScroll.vue?vue&type=script&lang=js"
export * from "./MugenScroll.vue?vue&type=script&lang=js"

import "./MugenScroll.vue?vue&type=style&index=0&id=57c39222&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c39222"]])

export default __exports__